import React, {useState} from "react";

export default function HomePage(props: any) {
    return (
        <div>
home
        </div>
    )
}
